// extracted by mini-css-extract-plugin
export default {"header":"modalHeader_header__eo5Vs","label":"modalHeader_label__1DQRK","cancel":"modalHeader_cancel__EmVtX"};